define([
	"dojo/_base/array",
	"dojo/_base/lang",
	"dojo/topic",
	"dijit/registry",
	"csi",
	"csi/_base/Deferred",
	"csi/store/Cache"
], function(array, lang, topic, registry, csi, Deferred, StoreCache) {

	// Object: mapping of view type to widget class controller
	var _factoryWidgets = {};

	// csi.view.Widget[]: keeps track of all open views
	var _factoryInstances = [];

	return {
		deleteView: function(/*csi.view.Widget*/view) {
			if (view) {
				_factoryInstances.dele(view);
			}
		},

		getControllerForType: function(/*String*/type) {
			// summary: return view controller for configured view type
			return _factoryWidgets[type];
		},

		getEnclosingView: function(/*DOMNode*/domNode) {
			// summary: find view that contains given domNode
			var w = registry.getEnclosingWidget(domNode);

			while (w && !w.defView && w.domNode.parentNode) {
				w = registry.getEnclosingWidget(w.domNode.parentNode);
			}

			return w;
		},

		getViews: function() {
			return _factoryInstances;
		},

		getView: function(/*String*/viewId, /*String?*/urlRoot, /*String?*/secondaryViewId, /*csi.view.Widget?*/parentView) {
			const a = this.getAllViews(viewId, urlRoot, secondaryViewId, parentView);
			if (!a) {
				return a;
			}

			if (a.length > 1) {
				// view is not unique
				console.warn("csi.view.getView: view is not unique: " + viewId);
			}

			return a.length ? a[0] : null;
		},

		getAllViews: function(/*String*/viewId, /*String?*/urlRoot, /*String?*/secondaryViewId, /*csi.view.Widget?*/parentView) {
			// summary: find view(s) based on id and option root url; if parentView given, then only return
			// view if it exists under the given parent
			var a = array.filter(_factoryInstances, function(v) {
				// first, check configured view id
				if (v.defView.getId() == viewId) {
					// second, apply secondaryViewId if given
					if (!secondaryViewId || (secondaryViewId == v.secondaryViewId)) {
						// finally, filter out views that do not exist under given parent
						return !parentView || v.isChildViewOf(parentView);
					}
				}

				return false;
			});

			if (urlRoot) {
				// filter views by root url
				a = array.filter(a, function(v) {
					return v.getViewURL() == urlRoot;
				});
			}

			return a.length ? a : null;
		},

		newView: function(/*View*/defView, /*Node?*/node, /*Object?*/params, /*Boolean*/bOmit) {
			// summary: create new view widget given XML definition based on type
			// NOTE: use this variant only if you know classes are already loaded for views
			// e.g. the controller class for the widget is already loaded
			var wc = defView.getClassController();
			var ctr = csi.syncRequire(wc || "csi/view/Widget");

			if (ctr && ctr.__esModule === true) {
				ctr = ctr.default;
			}

			if (typeof ctr !== "function") {
				console.assert(false, "newView: could not resolve widget class: " + wc);
				return null;
			}

			const viewParams = {defView};

			Object.assign(viewParams, params);
			Object.assign(viewParams, defView.classControllerParams);
			viewParams.cacheView = viewParams.cacheView || new StoreCache();

			if (node) {
				viewParams.urlRoot = node.$URL;
				viewParams.cacheView.cacheNode(node);
			}

			const view = new ctr(viewParams);

			// currently only the debug console is omitted - we don't want it factoring into any actual functionality
			if (!bOmit) {
				_factoryInstances.push(view);
			}

			topic.publish("/csi/view", view);

			return view;
		},

		newViewDeferred: function(/*View*/defView, /*Node*/node, /*Object?*/params, /*Boolean*/bOmit) {
			// summary: create new view widget after loading controller class on demand
			// TODO: Rework Slicer so that loadViewClasses is not needed, and then newViewDeferred is not necessary either
			var view = this.newView(defView, node, params, bOmit);
			if (view) {
				return view.loadViewClasses().then(function() {return view;});
			}

			return new Deferred().resolve();
		},

		/**
		 * Sets refresh on tab for all views with viewId
		 * @param {string} viewId 
		 */
		refreshAllViewsOnTab: function(viewId){
			const viewsToRefresh = this.getAllViews(viewId);
			viewsToRefresh?.forEach((view) => {
				view.refreshOnTabSwitch = true;
			});
		},

		registerViews: function(/*Object*/obj) {
			// summary: register new view types with view factory
			lang.mixin(_factoryWidgets, obj);
		}
	};
});